export default __webpack_public_path__ + "static/media/basketball.f9f2546d.svg";